import { Dialog, dialogClasses } from '@ori-ui/components';
import { styled } from '@ori-ui/mui';
import { lazy, Suspense } from 'react';
import type { FC } from 'react';

import { useBasketSharing } from '../../hooks';
import { logDebug } from '../../logger';
import { Loader } from '../Loader';
import { ShareButton } from '../ShareButton';
import type { SharingWrapperProps } from './types';

const CopyLinkPanel = lazy(async () => import('./CopyLinkPanel'));
const SharingPanel = lazy(async () => import('./SharingPanel'));

const SharingPopup = styled(Dialog)<{
  ownerState: { isCopyLinkOpen: boolean };
}>(({ ownerState: { isCopyLinkOpen }, theme }) => ({
  ...(isCopyLinkOpen && {
    [`&.${dialogClasses.header}`]: {
      paddingBottom: theme.spacing(6),
    },
    [`&.${dialogClasses.content}`]: {
      maxWidth: 540,
    },
  }),
}));

export const SharingWrapper: FC<SharingWrapperProps> = (props) => {
  const { copyLinkProps, isCopyLinkOpen, isPanelOpen, isPopupOpen, panelProps, popupProps, shareButtonProps } =
    useBasketSharing(props);

  logDebug('Rendering SharingWrapper.tsx, popupProps:', popupProps);

  return (
    <>
      <ShareButton {...shareButtonProps} />
      {isPopupOpen ? (
        <SharingPopup {...popupProps}>
          <>
            {isPanelOpen ? (
              <Suspense fallback={<Loader />}>
                <SharingPanel {...panelProps} />
              </Suspense>
            ) : null}
            {isCopyLinkOpen ? (
              <Suspense fallback={<Loader />}>
                <CopyLinkPanel {...copyLinkProps} />
              </Suspense>
            ) : null}
          </>
        </SharingPopup>
      ) : null}
    </>
  );
};
